module.exports = __webpack_public_path__ + "static/15-987bbd09a26a964a50801051bcc7d1a4.png";